module.exports = __webpack_public_path__ + "img/logo.dd8699f8.png";